export default function FaqSkeleton() {
  return (
    <section className="bg-background-global w-full py-5 md:py-18 animate-pulse">
      <div className="container">
        <div className="mb-6 h-8 w-80 rounded bg-gray-200"></div>
        <div className="space-y-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="rounded-lg bg-gray-200 p-4">
              <div className="mb-2 h-6 w-3/4 rounded bg-gray-300"></div>
              <div className="h-4 w-1/2 rounded bg-gray-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
